import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

let reduceMotion = localStorage.getItem('reduceMotion')

let sliders = document.querySelectorAll('.js-quoteSlider')

sliders.forEach( (slider) => {
    const quoteSlider = new Splide( slider, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        speed: reduceMotion == 'false' ? 300 : 0,
        arrows: true,
        pagination: true,
        isNavigation: true,
        autoplay: reduceMotion == 'false' ? true : false,
        interval: 10000,
        keyboard: 'focused',
    })
    quoteSlider.mount()
})

if(document.getElementById("js-trustedBySlider")){
    let trustedBySlider;

    // Grab the prefers reduced media query.
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    // Check if the media query matches or is not available.
    if (!mediaQuery || mediaQuery.matches) {
        // Slider with manual controls
        trustedBySlider = new Splide('#js-trustedBySlider', {
            type: 'loop',
            focus: 'center',
            autoWidth: true,
            gap: 80,
            arrows: true,
            pagination: false,
        });
        trustedBySlider.mount();
    } else {
        // Slider with auto scroll
        trustedBySlider = new Splide('#js-trustedBySlider', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            pauseOnHover: false,
            autoWidth: true,
            gap: 32,
            arrows: false,
            pagination: false,
            autoScroll: {
                speed: 1,
            },
        });

        trustedBySlider.mount({ AutoScroll });
    }

    let paused = false;
    $('#trustedBySliderPause').on('click', (e) => {
        const $target = $(e.target);
        const $pauseTxt = $('#trustedBySliderPauseText');
        const $resumeTxt = $('#trustedBySliderResumeText');
        const $pauseIcon = $('#trustedBySliderPauseIcon');
        const $playIcon = $('#trustedBySliderPlayIcon');
        if (!paused) {
            trustedBySlider.Components.AutoScroll.pause();
            paused = true;
            $resumeTxt.removeClass('hidden');
            $pauseTxt.addClass('hidden');
            $playIcon.removeClass('hidden');
            $pauseIcon.addClass('hidden');
        } else {
            trustedBySlider.Components.AutoScroll.play();
            paused = false;
            $pauseTxt.removeClass('hidden');
            $resumeTxt.addClass('hidden');
            $pauseIcon.removeClass('hidden');
            $playIcon.addClass('hidden');
        }
    });
}
